define('home/views/HomepageMarketingView',[
    'underscore',
    'jquery',
    'backbone-marionette',

    'core/utils',

    'home/templates/homepageMarketing',
], function (
    _,
    $,
    Marionette,

    coreUtils,

    homepageMarketingTemplate
) {
    'use strict';

    var animationEndEvent = coreUtils.animationEndEvent;
    var transitionEndEvent = coreUtils.transitionEndEvent;

    /**
     * The large banner that shows on the logged out homepage that promotes home
     * and publisher tools.
     *
     * Does not require a model.
     */
    var HomepageMarketingView = Marionette.ItemView.extend({
        template: homepageMarketingTemplate,

        events: {
            'click [data-action=close-marketing]': 'close',
        },

        initialize: function () {
            // When an item in the swap group of elements finishes an animation, swap
            // in another item.
            if (animationEndEvent)
                this.events[animationEndEvent + ' [data-swap-item]'] = this.swapItems;
        },

        swapItems: function (evt) {
            var $visibleItem = $(evt.target);

            var $nextItem = $visibleItem.next('[data-swap-item]');
            if (!$nextItem.length)
                // Loop back to the beginning if at the end of swap elements
                $nextItem = this.$('[data-swap-item]:first');

            $visibleItem.removeClass('active');
            $nextItem.addClass('active');
        },

        /**
         * Overwrites Marionette's close function in order to do a hide transition
         * before close.
         */
        close: function () {
            var boundClose = _.bind(Marionette.ItemView.prototype.close, this);
            if (transitionEndEvent)
                this.$el.on(transitionEndEvent, boundClose);
            else
                boundClose.call();

            this.$el.addClass('is-inactive');
        },
    });

    return HomepageMarketingView;
});

